/**
 * `<WorkspaceIcon>` — the workspace's top-left brand icon.
 *
 * Renders the workspace-provided `src` when set, and falls back to the app
 * default both when no URL is configured and when the configured URL fails to
 * load (a broken or incorrect link) — so an invalid icon never leaves a broken
 * image in the sidebar.
 */

import { cn } from "@cometchat-ai/ui-dashboard";
import { type SyntheticEvent } from "react";

const DEFAULT_ICON = "/favicon.png";

export function WorkspaceIcon({ src, className }: { src?: string | null; className?: string }) {
  const handleError = (e: SyntheticEvent<HTMLImageElement>) => {
    if (!e.currentTarget.src.endsWith(DEFAULT_ICON)) e.currentTarget.src = DEFAULT_ICON;
  };
  return (
    <img
      src={src || DEFAULT_ICON}
      onError={handleError}
      alt=""
      aria-hidden
      className={cn("rounded-md object-contain", className)}
    />
  );
}
